import colors from '../../colors';
import * as React from 'react';
import { CalculatorAttachment } from '../../../typedefs/store';
import styled from 'styled-components';
import * as CalculatorIcon from 'react-icons/lib/io/calculator';
import { formatCurrency } from '../../../util';

interface Props {
    attachment: CalculatorAttachment;
}

const CalculatorAttachment: React.SFC<Props> = ({ attachment }) => {
    return (
        <Wrapper className="conversations-attachment conversations-attachment-calculator">
            <IconWrapper className="conversations-attachment-icon">
                <CalculatorIcon size={32} />
            </IconWrapper>
            <CalculatorWrapper className="conversations-attachment-content">
                <Title>Payment Estimate</Title>
                <Text>
                    <div>
                        <Label>Vehicle Price</Label>: {formatCurrency(attachment.vehiclePrice, 0)}
                    </div>
                    <div>
                        <Label>Trade In Estimate</Label>:{' '}
                        {formatCurrency(attachment.tradeInValue, 0)}
                    </div>
                    <div>
                        <Label>Down Payment</Label>: {formatCurrency(attachment.downPayment, 0)}
                    </div>
                    <div>
                        <Label>Estimated Loan Amount</Label>:{' '}
                        {formatCurrency(attachment.loanAmount, 0)}
                    </div>
                    <div>
                        <Label>Estimated Monthly Payment</Label>:{' '}
                        {formatCurrency(attachment.monthlyPayment, 0)} for {attachment.term} months
                        at {attachment.rate}%
                    </div>
                </Text>
                <Disclaimer>
                    Does not include Sales Tax and Fees. Payment listed is with approved credit.
                </Disclaimer>
            </CalculatorWrapper>
        </Wrapper>
    );
};

export default CalculatorAttachment;

const Wrapper = styled.div`
    display: flex;
    align-items: center;
`;

const IconWrapper = styled.div`
    flex-grow: 0;
    flex-shrink: 0;
    padding-right: 10px;
`;
const CalculatorWrapper = styled.div`flex-grow: 1;`;

const Title = styled.div`margin-bottom: 5px;`;
const Text = styled.div`
    font-size: 0.8em;
    line-height: 1.3;
    margin-bottom: 10px;
`;

const Label = styled.span`font-weight: 400;`;

const Disclaimer = styled.div`
    font-style: italic;
    font-size: 0.65em;
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/Attachments/CalculatorAttachment.tsx